import { render, staticRenderFns } from "./CreditAssessmentLogsItem.vue?vue&type=template&id=1ba2ca42&scoped=true&"
import script from "./CreditAssessmentLogsItem.vue?vue&type=script&lang=js&"
export * from "./CreditAssessmentLogsItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=1ba2ca42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2ca42",
  null
  
)

export default component.exports